import React from 'react';
import logo from './assets/images/AIRA.jpg';
import bone from './assets/images/bone.jpg';
import covid from './assets/images/covid.jpeg';
import djarwani from './assets/images/djarwani.jpeg';
import evan from './assets/images/evan.jpeg';
import edy from './assets/images/edy.jpg';
import mushfi from './assets/images/mushfi.jpeg';
import mahdi from './assets/images/mahdipp.jpg';
import fisika from './assets/images/fisika.png';
import mipa from './assets/images/mipa.png';

import './App.css';
import {Nav,Navbar,Button,Form,Row,Col,
  FormControl, Jumbotron,Card,CardDeck, Container} from 'react-bootstrap';


function App() {
  return (
    <div className="Background">
       <Navbar collapseOnSelect expand="lg"  style ={{fontWeight:"bold",color: "#f5af19"}}>
        <Navbar.Brand> 
          <img src={logo} alt='logo' style={{width:90}}/>{'   '}
        </Navbar.Brand>
      <Nav className="mr-auto" style={{fontSize:"20px",color: "#f5af19"}}>
        <Nav.Link href="#home">Home</Nav.Link>
        <Nav.Link href="#features">Project</Nav.Link>
        <Nav.Link href="#pricing">Meet our team</Nav.Link>
        <Nav.Link href="#pricing">Contact</Nav.Link>
      </Nav>
      <Form inline>
        <FormControl type="text" placeholder="Search" className="mr-sm-2" />
        <Button variant="outline-info">Search</Button>
      </Form>
    </Navbar>
    <Jumbotron>
      <h1>Background</h1>
      <p style={{textAlign:"justify"}}> <b>AIRA</b> is the abbreviation of Aritificial Intelligence in Radiological Application. 
      was first formed in September 2019 in the department of Physics, Faculty of Mathematics and Natural Sciences, Universitas Indonesia.
      initiated by <b>Prof. Djarwani Soejoko</b>, she believes that AI will be very useful in the medical world,
       especially in the fields of medical physics, Indonesia must not only be a user, but must be a 
       leading innovator in AI technologies. Aira aspires to become the foremost applied AI research group in the field of radiology in Indonesia.
       through this website, we are trying to introduce our best applied research, so that in the future, mini-thesis,thesis, other research product will not only 
       pile up in the library but can be applied in the medical industry in the real field. We open wide opportunities to be able to work with any party for the 
       advancement of the Indonesian radiology world.
      </p>
      <h1>Projects</h1>
      <CardDeck>
        <Card>
          <Card.Img variant="top" src={bone} style ={{height:300}} />
          <Card.Body style={{backgroundColor:"#c31432"}}>
            <Card.Title>Bone Suppression</Card.Title>
            <Card.Text>
              we provide bone suppression from common x-ray image,   
            </Card.Text>
          </Card.Body>
        </Card>
        <Card>
          <Card.Img variant="top" src={covid} style ={{height:300}}/>
          <Card.Body style={{backgroundColor:"#c31432"}}>
            <Card.Title>Detection Covid 19</Card.Title>
            <Card.Text>
              we detect covid 19 from chest CT dicom images
            </Card.Text>
          </Card.Body>
        </Card>
        </CardDeck>

        <h1>Meet our team</h1>
        <div >
        <Row  className="justify-content-md-center">
          <Col md="auto"l>
            <Card style={{ width: '18rem' }}>
              <Card.Img variant="top" src={djarwani} style={{height:250}}/>
              <Card.Body style={{backgroundColor:"#c31432"}}>
                <Card.Title>Prof. Djarwani</Card.Title>
                <Card.Text>
                  Founder
                </Card.Text>
                <Button style={{backgroundColor: "#f5af19"}}>See my research</Button>
              </Card.Body>
            </Card>
            </Col>
        <Col md="auto">
            <Card style={{ width: '18rem' }}>
              <Card.Img variant="top" src={evan} style={{height:250}}/>
              <Card.Body style={{backgroundColor:"#c31432"}}>
                <Card.Title>Lukmanda Evan L., M.Sc</Card.Title>
                <Card.Text>
                  Supervisor
                </Card.Text>
                <Button style={{backgroundColor: "#f5af19"}}>See my research</Button>
              </Card.Body>
            </Card>
          </Col>
          </Row>
        <br/>
        <Row className="justify-content-md-center">
          <Col>
          <Card style={{ width: '18rem' }}>
              <Card.Img variant="top" src={edy} style={{height:250}}/>
              <Card.Body style={{backgroundColor:"#c31432"}}>
                <Card.Title>Eddy Kurniawan, M.Si</Card.Title>
                <Card.Text>
                  AI developer
                </Card.Text>
                <Button style={{backgroundColor: "#f5af19"}}>See my research</Button>
              </Card.Body>
            </Card>
          </Col>
          <Col>
          <Card style={{ width: '18rem' }}>
              <Card.Img variant="top" src={mahdi} style={{height:250}} />
              <Card.Body style={{backgroundColor:"#c31432"}}>
                <Card.Title>M. Mahdi Ramadhan, S.Si</Card.Title>
                <Card.Text>
                  AI and Software Developer
                </Card.Text>
                <Button style={{backgroundColor: "#f5af19"}}>See my research</Button>
              </Card.Body>
            </Card>
          </Col>
          <Col>
          <Card style={{ width: '18rem' }}>
              <Card.Img variant="top" src={mushfi} style={{height:250}}/>
              <Card.Body style={{backgroundColor:"#c31432"}}>
                <Card.Title>Al Mushfi Saputra, S.Si</Card.Title>
                <Card.Text>
                  AI Developer
                </Card.Text>
                <Button style={{backgroundColor: "#f5af19"}}>See my research</Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        </div>
        
      </Jumbotron>
      <Container>
        <h3 style={{color: "#f5af19"}}>Organized by:</h3>
        <Row className="justify-content-md-left">
          <Col md="auto">
            <img src ={fisika} alt="fisika" style={{width:200, height:90}}/>
          </Col>
          <Col md="auto">
            <img src={mipa} alt="mipa" style={{width:200, height:90}}/>
          </Col>
        </Row>
        <br/>
      </Container>
    </div>
  );
}

export default App;
